import '~/assets/css/rtl.styl';

export default {
  functional: true,
  render: () => null
};
